// extracted by mini-css-extract-plugin
export default {"divider":"AllActiveUsersList_divider__O07ex"};